import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown, Check } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const initials = (name) => (name || "").split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");

function Avatar({ opt, size = 24 }) {
  const url = opt?.avatar_url ? `${BACKEND}${opt.avatar_url}` : null;
  const style = { width: size, height: size };
  return url ? (
    <img src={url} alt={opt.name} className="rounded-full shrink-0 object-cover" style={{ ...style, border: "1px solid #EBE8E3" }} />
  ) : (
    <span className="rounded-full shrink-0 flex items-center justify-center font-semibold"
      style={{ ...style, fontSize: size * 0.42, background: "#F1DEDA", color: "#A83232", border: "1px solid #E9C9C3" }}>
      {initials(opt?.name) || "?"}
    </span>
  );
}

export function UserSingleSelect({ users, value, onChange, placeholder = "Vælg", testid, className = "", allowNone = true }) {
  const [open, setOpen] = useState(false);
  const sortedUsers = [...users].sort((a, b) => (a.name || "").localeCompare(b.name || "", "da", { sensitivity: "base" }));
  const selected = sortedUsers.find((u) => u.id === value) || null;
  const pick = (id) => { onChange(id); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex w-full items-center justify-between gap-2 rounded-xl border border-input bg-white px-2.5 text-sm ${className}`}>
          {selected ? (
            <span className="flex items-center gap-2 min-w-0">
              <Avatar opt={selected} size={22} />
              <span className="truncate text-[#1A1919]">{selected.name}</span>
            </span>
          ) : (
            <span className="truncate text-muted-foreground">{placeholder}</span>
          )}
          <ChevronDown className="h-4 w-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-1.5 rounded-xl" align="start">
        <div className="max-h-64 overflow-y-auto">
          {allowNone && (
            <button type="button" onClick={() => pick(null)} data-testid={`${testid}-option-none`}
              className="w-full flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-[#F3F1EC] text-left">
              <span className="h-6 w-6 rounded-full bg-[#F3F1EC] shrink-0" />
              <span className="text-sm text-muted-foreground flex-1">Ingen</span>
              {!value && <Check className="h-4 w-4 text-[#A83232]" />}
            </button>
          )}
          {sortedUsers.length === 0 && <p className="px-2 py-1.5 text-sm text-muted-foreground">Ingen brugere</p>}
          {sortedUsers.map((u) => (
            <button type="button" key={u.id} onClick={() => pick(u.id)} data-testid={`${testid}-option-${u.id}`}
              className="w-full flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-[#F3F1EC] text-left">
              <Avatar opt={u} size={24} />
              <span className="text-sm truncate flex-1">{u.name}</span>
              {value === u.id && <Check className="h-4 w-4 text-[#A83232] shrink-0" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
